export enum ManualWalletAssign {
  PLAYER = 'PLAYER',
  USERNAME = 'USERNAME',
}
